import cn from 'classnames'

import { Button } from 'core-components/library/button'
import { Tooltip } from 'core-components/library/tooltip'

import { PLAN_REVIEW_TRANSLATIONS } from '../../config/translations'
import { isPlanReviewJustificationValid } from '../../lib/isPlanReviewJustificationValid'
import { PlanReviewText } from '../PlanReviewText'

import styles from './JustificationAction.module.scss'

interface IJustificationActionProps {
  justification?: string
  canEdit: boolean
  onClick: () => void
}

export const JustificationAction = ({
  justification,
  canEdit,
  onClick,
}: IJustificationActionProps) => {
  const hasJustification = isPlanReviewJustificationValid(justification)
  const caption = hasJustification
    ? canEdit
      ? PLAN_REVIEW_TRANSLATIONS.justification.edit
      : PLAN_REVIEW_TRANSLATIONS.justification.provided
    : canEdit
      ? PLAN_REVIEW_TRANSLATIONS.justification.add
      : PLAN_REVIEW_TRANSLATIONS.justification.missing
  const iconClassName = cn('kbase', 'kbase-chat', 'kbase-sm', styles.icon, {
    [styles.iconComplete]: hasJustification,
    [styles.iconMissing]: !hasJustification,
  })
  const tooltipContent = hasJustification ? (
    <PlanReviewText
      text={PLAN_REVIEW_TRANSLATIONS.justification.details}
      replace={{ justification }}
    />
  ) : (
    <PlanReviewText text={caption} />
  )

  return (
    <Tooltip tipContent={() => <span>{tooltipContent}</span>}>
      <span className={styles.tooltipTarget}>
        <Button
          variant="outlined"
          color={hasJustification ? 'success' : 'danger'}
          icon={iconClassName}
          disabled={!canEdit}
          onClick={
            canEdit
              ? (event) => {
                  event.stopPropagation()
                  onClick()
                }
              : undefined
          }
        >
          <PlanReviewText text={caption} />
        </Button>
      </span>
    </Tooltip>
  )
}
